<template>
  <b-card-code title="" no-body>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-button
              variant="primary"
              @click="exportExcel"
            >
              <span class="text-nowrap">Export Excel</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="d-flex justify-content-between flex-wrap">
      <!-- sorting  -->
      <b-form-group label="Sort" label-size="sm" label-align-sm="left" label-cols-sm="3" label-for="sortBySelect" class="ml-1">
        <b-input-group size="sm">
          <b-form-select id="sortBySelect" v-model="sortBy" :options="sortOptions" >
            <template #first>
              <option value="">
                none
              </option>
            </template>
          </b-form-select>
          <b-form-select v-model="sortDesc" size="sm" :disabled="!sortBy" >
            <option :value="false">
              Asc
            </option>
            <option :value="true">
              Desc
            </option>
          </b-form-select>
        </b-input-group>
      </b-form-group>

      <!-- filter -->
      <b-form-group label="Filter" label-cols-sm="2" label-align-sm="left" label-size="sm" label-for="filterInput" class="mr-1" >
        <b-input-group size="sm">
          <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Type to Search"/>
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''">
              Clear
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>
    <b-table striped hover responsive class="position-relative" :per-page="perPage" :current-page="currentPage" :items="items" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
      <template #cell(updated_at)="data">
        {{ dateFormat(data.value) }}
      </template>
      <template #cell(detail)="data">
        <template v-for="(r_detal, indexs) in data.value">
          <b-badge variant="info" class="badge-glow" v-bind:key="indexs">
            {{ r_detal.legal_service_name }}
          </b-badge>
        </template>
      </template>
      <template #cell(payment)="data">
        <template v-for="(r_detail, indexs) in data.value">
          <b-badge :variant="payment[1][r_detail.payment_method]" class="badge-glow" v-bind:key="indexs">
            {{ payment[0][r_detail.payment_method] }}
          </b-badge>
        </template>
      </template>
      <template #cell(status)="data">
        <b-badge :variant="status[1][data.value]" class="badge-glow">
          {{ status[0][data.value] }}
        </b-badge>
      </template>
      <template #cell(icon)="data">
        <b-img :src="data.value" />
      </template>
      <template #cell(total)="data">
        {{ data.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") }}
      </template>
      <template #cell(action)="row">
        <b-button v-b-modal.modal-center :to="{ path: '/report/detail/'+ row.item.id}"
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="outline-primary"
          class="btn-icon">
          <!-- <feather-icon icon="CheckCircleIcon"/> -->
        Detail
        </b-button>
      </template>
    </b-table>
    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <b-form-group label="Per Page" label-cols="6" label-align="left" label-size="sm" label-for="sortBySelect" class="text-nowrap mb-md-0 mr-1">
        <b-form-select id="perPageSelect" v-model="perPage" size="sm" inline :options="pageOptions" />
      </b-form-group>
      <!-- pagination -->
      <div>
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" first-number last-number prev-class="prev-item" next-class="next-item" class="mb-0">
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </b-card-body>
  </b-card-code>
</template>
<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { BTable, BRow, BCol, BImg, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem } from 'bootstrap-vue'
import { mapState } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store/index'
import moment from 'moment'
import XLSX from 'xlsx'
const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x,i) => ({name:XLSX.utils.encode_col(i), key:i}))
const _SheetJSFT = ['xlsx', 'xlsb', 'xlsm', 'xls', 'xml', 'csv', 'txt', 'ods', 'fods', 'uos', 'sylk', 'dif', 'dbf', 'prn', 'qpw', '123', 'wb*', 'wq*', 'html', 'htm'].map(function(x) { return '.' + x }).join(',')
export default {
  components: { XLSX, moment, BCardCode, BTable, BRow, BCol, BImg, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem, ToastificationContent},
  data () {
    let startDate = new Date()
    let endDate = new Date()
    return {
			SheetJSFT: _SheetJSFT,
			dateRange: {startDate, endDate},
      dir: false,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      status: [{
        AC: 'Aktif Belum Dibayar', WC: 'Menunggu Konfirmasi', DC: 'Tolak Konsultasi', SC: 'Aktif Sudah Dibayar', EC: 'Pembayaran Expired',LS: 'Sedang Layanan Hukum', ED: 'Transaksi Selesai', SH: 'Terjadwal',
      },
      {
        AC: 'light-primary', WC: 'light-success', DC: 'light-danger', EC: 'light-warning', SC: 'light-info', LS: 'light-info', ED: 'light-info', SH: 'light-info',
      }],
      payment: [{
        XD: 'Xendit', JH: 'Universal IOT', MT: 'Midtrans',
      },
      {
        XD: 'light-primary', JH: 'light-primary', MT: 'light-primary',
      }]
    }
  },
  computed: {
    ...mapState({ 
      totalRows: state => state.transaction.totalRows, 
      fields: state => state.transaction.fields, 
      items: state => state.transaction.items, 
      perPage: state => state.transaction.perPage, 
      pageOptions: state => state.transaction.pageOptions, 
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    dateFormat () {
      return create_at => this.$options.filters.formatDate(create_at)
    },
    direction () {
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      this.dir = false
      return this.dir
    }
  },
  methods: {
    formatDates: function (value) {
      console.log(value)
      var dateFormat = dateFormat ? dateFormat : 'DD-MM-YYYY HH:mm:ss'
      if (value) {
        return moment(String(value)).format('DD-MM-YYYY HH:mm:ss')
      }
    },
		moment: function (date) {
      return moment(date)
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.$store.state.totalRows = filteredItems.length
      this.currentPage = 1
    },
    advanceSearch (val) {
      this.searchTerm = val
    },
    rowOnDelete (id) {
      this.$bvModal
      .msgBoxConfirm('Please confirm that you want to delete everything.', {
        title: 'Please Confirm', size: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'No', cancelVariant: 'outline-secondary', hideHeaderClose: false, centered: true,
      })
      .then(value => {
        if (value === true){
          this.$store.dispatch('transaction/remove', id)
          .then(response => {
            if (response.status === 200) {
              this.$store.dispatch('transaction/getAll')
              this.notification('Success','CheckIcon','success','You have successfully')
            } else {
              this.notification('Failed','CloseIcon','danger','You have unsuccessful')
            }
          },
          error => {
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          }) 
        }
      })
    },
    exportExcel(evt) {
      const jsons = []
      for (let x = 0; x < this.items.length; x++) {
        jsons[x] = {
          'TransactionID': this.items[x].TransactionID,
          'consultation_number': this.items[x].consultation_number,
          'created_at': moment(String(this.items[x].created_at)).format('DD-MM-YYYY HH:mm:ss'),
          'date': moment(String(this.items[x].date)).format('DD-MM-YYYY HH:mm:ss'),
          'deleted_at': moment(String(this.items[x].date)).format('DD-MM-YYYY HH:mm:ss'),
          'fees': this.items[x].fees,
          'id': this.items[x].id,
          'invoice_number': this.items[x].invoice_number,
          'payment_method': this.items[x].payment_method,
          'practition_email': this.items[x].practition_email,
          'practition_id': this.items[x].practition_id,
          'practition_name': this.items[x].practition_name, 
          'practition_profession': this.items[x].practition_profession,
          'practition_response': this.items[x].practition_response,
          'practition_response_time': moment(String(this.items[x].practition_response_time)).format('DD-MM-YYYY HH:mm:ss'),
          'reference_number': this.items[x].reference_number,
          'status': this.items[x].status,
          'sub_total': this.items[x].sub_total,
          'taxes': this.items[x].taxes,
          'total': this.items[x].total,
          'updated_at': moment(String(this.items[x].updated_at)).format('DD-MM-YYYY HH:mm:ss'),
          'user_email': this.items[x].user_email,
          'user_id': this.items[x].user_id,
          'user_name': this.items[x].user_name
        }
      }
      const data_json = XLSX.utils.json_to_sheet(jsons)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, data_json, 'data')
			XLSX.writeFile(wb, 'Transaction_Recap_'+moment(this.dateRange.startDate.toISOString()).format('DD-MM-YYYY')+'_'+moment(this.dateRange.endDate.toISOString()).format('DD-MM-YYYY')+'.xlsx')
		},
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    }
  },
  directives: {
    Ripple
  },
  mounted() {
    // Set the initial number of items
    this.$store.state.totalRows = this.items.length
  },
  created () {
    this.$store.dispatch('transaction/getAll')
  }
}
</script>